<template>
  <div class="aboutCompanyContent">
    <div v-for="el in items" :key="el.id" class="aboutCompanyItems" >
      <div v-html="el.name" style="display: flex; flex: 1;"></div>
      <div v-html="el.content"></div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'

export default {
  setup(props, context) {
    const { $store } = context.root
    const items = ref([])
    const { makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('data/fetchAboutUsInfo'),
    })
    onMounted(async () => {
      const response = await makeRequest()
      items.value = response
    })
    return {
      items,
    }
  },
}
</script>

<style lang="scss">
.aboutCompanyContent{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow: hidden;
}
.aboutCompanyItems{
  width: 100%;
}
</style>
